import "./components/ad-slot.js";
import "./components/cancellation-and-withdrawal-validation.js";
import "./components/language-dropdown.js";
import "./components/welcome-user.js";
import "./components/nav-mobile.js";
import "./components/form-autosave.js";
import "./components/buy-credits-button.js";
import "./components/purchase-button.js";
import { initializeAds } from "./ads/ad-provider.js";
import { initTmgConfig } from "./config/tmg-config.js";
import { initLogger } from "./logger.js";
import { registerServiceWorker } from "./sw-client.js";

export { logger } from "./logger.js";

//
// Initialize logger as early as possible to capture logs from the start
//
initLogger();

//
// Register service worker
// Note: This should be done after the logger is initialized, but before we do much else.
//
registerServiceWorker();

// Fetch WebLive /config and expose as window.tmgConfig for global access.
initTmgConfig();

// Initialise ads (reads server-injected config, selects provider)
initializeAds();
